import { Box, Typography, Card, CardContent } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import PageHeader from '../components/PageHeader';

export default function Marketing() {
  return (
    <Box>
      <PageHeader titulo="Marketing" />
      <Card>
        <CardContent sx={{ textAlign: 'center', py: 6 }}>
          <ConstructionIcon sx={{ fontSize: 60, color: '#ccc', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" mb={1}>
            Em construção
          </Typography>
          <Typography variant="body2" color="text.secondary">
            O módulo de Marketing está sendo desenvolvido e estará disponível em breve.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}